import { render, staticRenderFns } from "./PeerStake.vue?vue&type=template&id=e172976a&scoped=true&"
import script from "./PeerStake.vue?vue&type=script&lang=ts&"
export * from "./PeerStake.vue?vue&type=script&lang=ts&"
import style0 from "./PeerStake.vue?vue&type=style&index=0&id=e172976a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e172976a",
  null
  
)

export default component.exports